<style lang="less" scoped>
.budget-contain {
  overflow: auto;
  .text-center {
    text-align: center;
  }
  .selected-btn {
  color: #1976d2 !important;
}
  /deep/ .fixed {
    position: sticky !important;
    position: -webkit-sticky !important;
    background: white;
    box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  }
  /deep/ .fixed-0 {
    right: 0;
  }
    /deep/ .fixed-100 {
    right: 100px;
  }
  /deep/ .min-width-100 {
    display: inline-block;
    width: 100px;
  }
  .table {
    height: 100%;
    
    /deep/.v-data-table__wrapper  {
      height: 100%;
      overflow: auto;
     table {
       thead {
         tr {
           th {
             padding: 8px;
             // font-size: 0.7rem;
           }
         }
       }
       .amendment {
         padding: 8px;
         // font-size: 0.5rem;
       }
       .dispaly-more-button {
         color: #1976d2;
       };
        .dispaly-more-button:hover {
           cursor: pointer;
         }
     }
    }
      ::-webkit-scrollbar {
          height: 8px;
          width: 8px;
          background-color: #fafafa;
        }
          /* 滚动槽 */
        // ::-webkit-scrollbar-track {
        //   border-radius:5px;
        // }

        /* 滚动条滑块 */
        ::-webkit-scrollbar-thumb {
          border-radius:5px;
          background:#c1c1c1;
        }
        ::-webkit-scrollbar-thumb:hover {
            background:#7d7d7d
        }
    
    }
}
</style>
<template>
  <div
    class="budget-contain"
    :style="{
      height: containHeight+'px'
    }"
  >
    <div style="display:flex">
      <div style="display:flex;align-items:center;margin-right:10px">
        <v-btn-toggle
          v-if="type===2"
          v-model="params.search_type"
          borderless
          dense
          active-class="selected-btn"
          @change="changeSearchType"
        >
          <v-btn value="mine">
            <span>我发起的</span>
          </v-btn>
          <v-btn value="pending">
            <span>待我处理</span>
          </v-btn>
          <v-btn value="related">
            <span>与我相关</span>
          </v-btn>
        </v-btn-toggle>
      </div>
      <SearchBar 
        v-model="params"
        cols="4"
        style="flex:1;max-width:700px"
        :fields="searchFields"
      />
      <div style="display:flex;align-items:center">
        <v-btn
          v-if="addNewDis"
          depressed
          color="primary"
          style="margin-left:10px"
          @click="openEditModal()"
        >
          新增预算单
        </v-btn>
        <v-btn
          v-if="checkFinBuget"
          depressed
          color="primary"
          style="margin-left:10px"
          @click="openBugetModal"
        >
          已获批额度
        </v-btn>
      </div>
    </div>
    <div :style="{height: `${containHeight-95}px`}">
      <v-data-table
        ref="test"
       
        :headers="tableFields"
        :items="dataList"
        :loading="loading.getTableLoading"
        :items-per-page="Infinity"
        loading-text="数据加载中..."
        hide-default-footer
      >
        <template v-slot:no-data>
          <div>
            暂无数据
          </div>
        </template>
        <template
          v-slot:item="{ item,headers }"
        >
          <tr
            :style="{
              color:item.del?'#757575':'',
              background: item.del?'#F5F5F5':''
            }"
          >
            <td
              v-for="(child,index) in headers"
              :key="index"
              class="amendment"
              :class="{
                fixed: child.fixed,
                'text-center': child.align==='center',
                'text-right': child.align==='right',
            
              }"
              :style="{
                right:child.fixed? child.right+'px':''
              }"
            >
              <!-- uid -->
              <div v-if="child.value==='name'">
                <p style="margin:0"> 
                  <a @click="editChild(item)">{{ item.name }}</a>
                </p>
                <p
                  v-show="item.important"
                  class="color-error"
                  style="margin-left:5px;margin:0"
                >
                  [管理团队审批单]
                </p>
              </div>
              <div v-else-if="child.value==='quarter_start_at'">
                {{ tableDispalyDate(item.quarter_start_at) }}
              </div>
              <div v-else-if="child.value==='apply_reason'">
                <div v-show="item.display_all || item.apply_reason.length<=15">
                  <span>
                    {{ item.apply_reason }}
                  </span>
                  <span
                    v-show="item.apply_reason.length>15"
                    class="dispaly-more-button"
                    @click="displayAll(item)"
                  >  收起</span>
                </div>
                <div v-show="item.apply_reason.length>15&&!item.display_all">
                  <span>
                    {{ item.apply_reason.slice(0,15) }}
                  </span>
                  <span
                    v-show="item.apply_reason.length>15"
                    class="dispaly-more-button"
                    @click="displayAll(item)"
                  >...更多</span>
                </div>
              </div>
              <div v-else-if="child.value==='apply_team_id'">
                {{ (product_teams_hash[item.apply_team_id]||{}).name }}
              </div>
              <div v-else-if="child.value==='type'">
                <UserFlowBase
                  v-if="!!item.user_flow"
                  :model="item"
                  :user_flow="item.user_flow||{}"
                  :show_handles="true"
                />
                <span v-else>
                  -
                </span>
              </div>
              <div v-else-if="child.value==='total_amount'">
                {{ ['0',0,'0.00'].includes(item.total_amount)?'-':formattingNumber(item.total_amount,2) }}
              </div>
              <div v-else-if="child.value==='actions'&&!item.del">
                <v-menu
                  :fixed="false"
                  top
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      text
                      v-bind="attrs"
                      v-on="on"
                    >
                      操作
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item v-if="addNewDis">
                      <v-list-item-title>
                        <v-btn
                          text
                          color="primary"
                          style="margin-right:10px"
                          block
                          :disabled="!item.editable"
                          @click="openEditModal(item)"
                        >
                          编辑
                        </v-btn> 
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="setImportantDis">
                      <v-list-item-title>
                        <v-btn
                          text
                          color="primary"
                          style="margin-right:10px"
                          block
                          :disabled="!item.editable"
                          @click="setItemImportant(item)"
                        >
                          {{ !item.important?'设置为管理团队审批单':'取消管理团队审批单' }}
                        </v-btn> 
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-btn
                          text
                          color="primary"
                          style="margin-right:10px"
                          block
                          @click="discardItem(item)"
                        >
                          废弃
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div v-else-if="child.value==='actions'&&item.del">
                -
              </div>
              <div v-else>
                {{ item[child.value] }}
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <RootEditModal
      v-if="addNewDis"
      ref="rootEditModal"
      @success="editSuccess"
    />
    <ShowBugetDetail
      v-if="checkFinBuget"
      ref="showBugetDetail"
    />
    <div
      v-if="params.total"
      class="line paginate-fix-bottom"
      style="padding-top:0px;padding-bottom:0px;"
    >
      <Pagination 
        :total="params.total"
        :page-size="params.per_page"
        :current="params.page"
        :size-arr="[10,20,50]"
        @pageChange="pageChange"
        @changePageSize="changePageSize"
      />
    </div>
    <ConfirmDiscardModal
      ref="discard_modal"
      @finish="onDiscardItem"
    />
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  // import Vue from 'vue'
  // import VTextarea from 'vuetify'
  import { formattingNumber } from '../../../libs/util'
  import RootEditModal from './components/RootEditModal'
  import ShowBugetDetail from './components/ShowBugetDetail'
  import Pagination from '../../../vuetify_custom/v-pagination'
  import UserFlowBase from '../../components/flow/user_flow_base'
  import { table_fields } from './fields'
  import SearchBar from '@/vuetify_custom/v-form'
  import { getBudgetOrderListApi, getBudgetOrderListAboutMeApi, budgetOrderDeleteApi, budgetOrderChangeImportantApi } from './service'
  import { DATE_DAY_FORMATE } from '../../../libs/constants'
  import ConfirmDiscardModal from './ConfirmDiscardModal'
  export default {
    components: {
      RootEditModal,
      Pagination,
      UserFlowBase,
      ShowBugetDetail,
      SearchBar,
      ConfirmDiscardModal,
    },
    props: {
      type: {
        type:Number
      }
    },
    data() {
      this.formattingNumber = formattingNumber
      return {
        loading: {
          getTableLoading:false
        },
        params: {
          search:'',
          status: 'all', // 
          quarter_start_at: '',
          page:1,
          per_page:20,
          total: 0,
          search_type: 'mine'
        },
        dataList: [],
      }
    },
    computed: {
      // 新增与编辑的权限
      addNewDis() {
        const current_hash = this.$store.state.hash_authority || {}
        const fin = this.type === 1 && current_hash['fin_buget_jurisdiction']
        const mine = this.type === 2 && current_hash['mine_fin_buget_jurisdiction']
        return fin || mine
      },
      checkFinBuget() {
        const current_hash = this.$store.state.hash_authority || {}
        const fin = this.type === 1 && current_hash['fin_check_fin_buget']
        const mine = this.type === 2 && current_hash['mine_check_fin_buget']
        return fin || mine
      },
      // 设置为重要或者取消设置为重要的权限
      setImportantDis() {
        const current_hash = this.$store.state.hash_authority || {}
        const fin = this.type === 1 && current_hash['fin_buget_set_important']
        const mine = this.type === 2 && current_hash['mine_fin_buget_set_important']
        return fin || mine
      },
      tableFields() {
        return table_fields
      },
      containHeight() {
        const window_height = this.$store.state.window_height;
        return window_height - 180;
      },
      searchFields() {
        return [
          {
            label: '状态',
            type: 'select_field',
            key:'status',
            clearable:true,
            cols: 3,
            items: [
              {
                text: '全部',
                value: 'all'
              },
              {
                text: '进行中',
                value: 'pending'
              },
              {
                text: '已完成',
                value: 'finished'
              },
            ],
            change:() => {
              this.proxyGetData()
            }
          },
          {
            label: '季度',
            type: 'month_field',
            key: 'quarter_start_at',
            cols: 3,
            'allowed-dates': this.allowedMonths,
            clearable:true,
            selected_close: true,
            'click:clear':() => this.proxyGetData(),
            change:() => this.proxyGetData(),
          },
          {
            label: '搜索',
            type: 'text_field',
            key: 'search',
            cols: 6,
            placeholder: '请输入审批名称、团队、事由等',
            'append-icon':'mdi-magnify',
            'single-line': true,
            clearable:true,
            'click:clear':() => this.proxyGetData(),
            'click:append': () => this.proxyGetData(),
            'keydown.enter': () => this.proxyGetData(),
          }
        ]
      },
      ...mapGetters('async', {
        product_teams_hash: 'product_teams_hash',
      }),
    },
    mounted() {
      const showHintModal = localStorage.getItem('fin_budget_root_hint_modal')
      if (!showHintModal) {
        this.$vModal.info({
          title: '提示',
          content: `点击【审批名称】可查看编辑子单`,
          onOk() {
            localStorage.setItem('fin_budget_root_hint_modal', true)
          }
        })
      }
      if (this.type === 1) {
        this.params.search_type = ''
      }
      this.proxyGetData()
    },
    methods:{
      allowedMonths(date) { // 季度开始月份可选
        const can_select = ['01', '04', '07', '10']
        
        if (can_select.includes(date.slice(-2))) {
          return true
        }
        return false
      },
      openBugetModal() {
        this.$refs.showBugetDetail.show()
      },
      setItemImportant(item) {
        this.$vModal.confirm({
          title: '提示',
          content: item.important ? '确认取消重要预算？' : '确认设置为重要预算？',
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            budgetOrderChangeImportantApi({id: item.id}).then(() => {
              this.$Message.success({
                content: '设置成功!'
              });
              destroy()
              this.proxyGetData()
            }).finally(() => {
              stopLoading()
            })
          }
        })
      },
      displayAll(item) {
        if (item.display_all) {
          item.display_all = false
          return 
        }
        this.$set(item, 'display_all', true)
      },
      deleteItemSuccess() {
        this.params.page = 1
        this.proxyGetData()
      },
      discardItem(item) {
        this.$refs.discard_modal.edit(item.id);
        // this.$vModal.confirm({
        //   title:'废弃预算申请单',
        //   loading:true,
        //   onOk({stopLoading, destroy} = {}) {
        //     budgetOrderDeleteApi({id:item.id, del_reason:inputvalue}).then(() => {
        //       _this.proxyGetData()
        //       this.$Message.success({
        //         content: '废弃成功!'
        //       });
        //       setTimeout(() => destroy(), 100)
        //     }).finally(() => {
        //       stopLoading()
        //     })
        //   },
        //   render(h) {
        //     return h('v-textarea', {
        //       props: {
        //         outlined:true,
        //         place:'',
        //         value: '',
        //         rows:3,
        //         'auto-grow':true
        //       },
        //       on: {
        //         input(data) {
        //           inputvalue = data
        //         }
        //       }
        //     })
        //   }
        // })
      },
      onDiscardItem(params) {
        const _this = this;
        budgetOrderDeleteApi({...params}).then(() => {
          _this.proxyGetData()
          this.$Message.success({
            content: '废弃成功!'
          });
        })
      },
      editSuccess(isCreate, { budget_order}) {
        if (isCreate) {
          this.params.page = 1
          this.$vModal.confirm({
            title: '提示',
            cancelText:'不了，稍后新增',
            content: '是否立即新增子单？',
            onOk:() => {
              this.editChild(budget_order)
            },
            onCancel: () => {
              this.proxyGetData()
            }
          })
          return 
        }
        // console.log(budget_order)
        setTimeout(() => {
          this.proxyGetData()
        }, 500)
      },
      proxyGetData(_params) {
        const getData = this.type === 1 ? getBudgetOrderListApi : getBudgetOrderListAboutMeApi
        // eslint-disable-next-line
        const { total,quarter_start_at:quarter_start_at_clone, ...other } = _params || this.params
        const quarter_start_at = quarter_start_at_clone ? quarter_start_at_clone + '-01' : null
        this.loading.getTableLoading = true
        getData({...other, quarter_start_at}).then(item => {
          this.dataList = item.budget_orders
          this.params.page = item.cur_page
          this.params.per_page = item.per_page
          this.params.total = item.total_count
        }).finally(() => {
          this.loading.getTableLoading = false
        })
      },
      openEditModal(data) {
        this.$refs.rootEditModal.show(data)
      },
      dateFormate(date) {
        return moment(date).format(DATE_DAY_FORMATE)
      },
      editChild({ id }) {
        const current_path = this.type === 1 ? '/fin/budget/detail' : '/mine/budget/detail'
        this.$router.push({path: current_path, query: { id, rt: new Date().getTime() }});
      },
      changeSearchType(search_type) {
        this.proxyGetData({
          ...this.params,
          search_type,
        })
      },
      pageChange(page) {
        this.proxyGetData({
          ...this.params,
          page,
        })
      },
      changePageSize(pageSize) {
        this.proxyGetData({
          ...this.params,
          per_page:pageSize,
          page:1
        })
      },
      tableDispalyDate(date) {
        if (!date) {
          return '-'
        }
        const date_c = date.slice(0, 7)
        return `${date_c}【第${Math.ceil(date_c.slice(-2) / 3)}季度】`
      }
    },
  }
</script>
